import { createApp } from 'vue'
import App from '@/page/vue/2024/event/sandbox.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import { Swipe, SwipeItem } from 'vant'
import 'vant/lib/index.css'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    ratio: 100,
});

tongji(); //统计
initShare({
  title: 'ISC.AI 2024创新独角兽沙盒大赛开启招募!',
  desc: '6月17日—7月12日，安全、AI、高校新星三大赛道开启招募',
  imgUrl: 'https://p1.ssl.qhimg.com/t11b673bcd6d16b49ec39379c07.png',
  link: window.location.href
})


const app = createApp(App)
app.use(Swipe)
app.use(SwipeItem)
app.mount('#app')
